export default __webpack_public_path__ + "static/media/github.fe464e80.svg";